import { pricebook } from '@/utilities/priceBook'
import {
  loadFixedBandwidths,
  loadIxTypes,
  loadLocations,
  loadMveLocations,
  loadManagedCompanies,
  loadPartnerPorts,
  loadTransitEnabledMarkets,
  loadSuppliers,
  loadMveImages,
  loadMveVariants,
  searchCompanies,
} from '@/utilities/megalithApi'
import { internalToValue } from '@/helpers'

const HALF_HOUR = 1000 * 60 * 30
const FIVE_MINUTES = 1000 * 60 * 5

export function locationsQuery() {
  return {
    queryKey: ['locations'],
    queryFn: loadLocations,
    staleTime: HALF_HOUR,
  }
}

export function mveLocationsQuery(mveImageId) {
  return {
    queryKey: ['mveLocations', mveImageId],
    queryFn: () => loadMveLocations(internalToValue(mveImageId)),
    staleTime: HALF_HOUR,
  }
}

export function suppliersQuery() {
  return {
    queryKey: ['suppliers'],
    queryFn: loadSuppliers,
    staleTime: HALF_HOUR,
  }
}

export function partnerPortsQuery() {
  return {
    queryKey: ['partnerPorts'],
    queryFn: loadPartnerPorts,
    staleTime: HALF_HOUR,
  }
}

export function transitEnabledMarketsQuery() {
  return {
    queryKey: ['transitEnabledMarkets'],
    queryFn: loadTransitEnabledMarkets,
    staleTime: HALF_HOUR,
    select: markets => [...new Set(markets.map(({ countryCode }) => countryCode))],
  }
}

export function managedCompaniesQuery() {
  return {
    queryKey: ['managedCompanies'],
    queryFn: loadManagedCompanies,
    staleTime: HALF_HOUR,
  }
}

export function ixTypesQuery(locationId) {
  return {
    queryKey: ['ixTypes', locationId],
    queryFn: () => loadIxTypes(locationId),
    staleTime: HALF_HOUR,
  }
}

export function fixedBandwidthsQuery(productUid, cloudServiceProvider) {
  return {
    queryKey: ['fixedBandwidths', productUid, cloudServiceProvider],
    queryFn: () => loadFixedBandwidths(productUid, cloudServiceProvider),
    staleTime: HALF_HOUR,
  }
}

export function pricebookQuery(resourceType, payload, config) {
  return {
    // NOTE: Here the config is unwrapped in the key to make it easy to serialise when needed with JSON.stringify.
    queryKey: ['pricing', resourceType, payload, internalToValue(config)],
    queryFn: () => pricebook[internalToValue(resourceType)](payload, config),
    staleTime: HALF_HOUR,
  }
}

export function searchCompaniesQuery(search, activeOnly) {
  return {
    queryKey: ['companySearch', search, activeOnly],
    queryFn: () => searchCompanies(search, activeOnly),
    staleTime: FIVE_MINUTES,
  }
}

export function mveImagesQuery() {
  return {
    queryKey: ['mveImages'],
    queryFn: loadMveImages,
    staleTime: HALF_HOUR,
  }
}

export function mveVariantsQuery() {
  return {
    queryKey: ['mveVariants'],
    queryFn: loadMveVariants,
    staleTime: HALF_HOUR,
  }
}
